import React, { useState, useEffect, useContext, useRef } from "react";
import "../Frontend/UserProfile/UserProfile.css";
import { Link, useNavigate, useParams } from "react-router-dom";
import api from "../../services/api";
import iq_api_v2 from "../../services/iqApiV2";
import APP_CONFIG from "../../config/appConfig";
import useAuth from "../../hooks/useAuth";
import { Form, Button } from "react-bootstrap";
import { useUser } from "../../context/UserContext";
import ScreenLoader from "../HtmlElements/ScreenLoader";
import Alert from "../HtmlElements/Alert";
import { useConfig } from "../../context/AppConfigContext";
import UserPreferenceSidebar from "./UserPreferenceSidebar";
import * as FeatherIcon from "react-feather";
import Multiselect from "multiselect-react-dropdown";
import { Row, Col, Table } from "react-bootstrap";
import qs from "qs";
import { useWebSocket } from "../Frontend/uiUtils/useWebSocket";
import { displayFormattedDate } from "../../services/commonService";
import ConfirmDialog from "../HtmlElements/ConfirmDialog";
import AccountList from "./ManageAccounts/AccountList";
import UserList from "./ManageAccounts/UserList";
import ContactSettings from "./ContactSettings";
import Signals from "./Signals";
import { useAuthorizedUser } from "../../context/AuthorizedUserContext";
import AutoNurtureMemory from "./autoNurtureMemory/AutoNurtureMemory";

export default function Personalisation() {
  useAuth();
  const { user } = useUser();
  const current_role_key = user?.role_key;

  const [loader, setLoader] = useState(false);
  const [errors, setErrors] = useState({});
  const [isGenerating, setIsGenerating] = useState(false);
  const [apiError, setApiError] = useState("");
  // const [image, setImage] = useState('');
  const [showDropdown, setShowDropdown] = useState(false);
  const [accountOptions, setAccountoptions] = useState([]);
  const [offerings, setOfferings] = useState([]);
  const [contactKeywords, setContactKeywords] = useState([]);
  const [selectedOffering, setSelectedOffering] = useState(null);
  const [keywordInput, setKeywordInput] = useState("");
  const [showOfferingForm, setShowOfferingForm] = useState(false);
  const [showOfferingUploadForm, setShowOfferingUploadForm] = useState(false);
  const [useCaseFileIds, setUseCaseFileIds] = useState([]);
  const [useCaseDocuments, setUseCaseDocuments] = useState([]);
  const [activeTab, setActiveTab] = useState('products');
  const { isAuthorized, isAuthLoading } = useAuthorizedUser();
  const [uploadOfferingsFormData, setUploadOfferingsFormData] = useState({
  uploadType: "",
  upload_product_file: ''
})

  // $$$$$$$$$$$$$
  const [apiSuccess, setApiSuccess] = useState('');
  // const [apiError, setApiError] = useState('');
  const [templateFiles, setTemplateFiles] = useState([]);
  const [pitchFiles, setPitchFiles] = useState([]);
  const [showMemoryModal, setShowMemoryModal] = useState(false);
  const [memoryType, setMemoryType] = useState("global");
  const [subType, setSubType] = useState("");
  const [selectedFile, setSelectedFile] = useState(null);
  const [sectionToUpload, setSectionToUpload] = useState("");
  const [refreshFn, setRefreshFn] = useState(() => {});
  const [activeDocTab, setActiveDocTab] = useState('products');
  const [productDocs, setProductDocs] = useState([]);
  const [useCaseTypeDocs, setUseCaseTypeDocs] = useState([]);
  const [verticalDocs, setVerticalDocs] = useState([]);
  const [globalDocs, setGlobalDocs] = useState([]);
  const [tempDocs, setTempDocs] = useState([]);
  const [memoryTypeError, setMemoryTypeError] = useState("");
  const [selectFileError, setSelectFileError] = useState("");
  const [currentDeletingInfo, setCurrentDeletingInfo] = useState({})

  // $$$$$$$$$$$$$
  const fileInputRef = useRef(null);
  // For selectedOffering.contactKeywords, ensure it’s an array during initialization.
  const isValidKeywordArray = (keywords) =>
    keywords.every((kw) => /^[A-Za-z0-9 ]*$/.test(kw));

  const geographyOptions = [
    "Asia",
    "Middle East",
    "Africa",
    "Europe",
    "UK",
    "Australia",
    "New Zealand",
    "North America",
    "Latin America",
  ];

  const notificationOptions = {
    Realtime: "Realtime",
    Daily: "Daily",
    Weekely: "Weekely",
  };

  const useCaseOptions = {
    account_plan: "Account Plan",
    maximize_pipe: "Maximize Pipe",
    targated_reach_out: "Targated Reach Out",
    meeting_prep: "Meeting Prep",
    nudges: "Nudges"
  };

  const [formData, setFormData] = useState({
    accounts: [],
    geographies: geographyOptions,
    notification: "",
    useCase: ""
  });

  const navigate = useNavigate();
  const { userId, clientName } = useParams();

  const { appConfig } = useConfig();

  const [description, setDescription] = useState("");
  const [wsUrl, setWsUrl] = useState(null);
  const messageBack = (data) => {
    if (data?.status === "completed" && data?.result?.description) {
      const description = data.result.description;
      // console.log("Generated Description:", description);

      setDescription(description);
      setSelectedOffering((prev) => ({
        ...prev,
        description,
      }));
      if(isGenerating){
        setIsGenerating(false);
      }
    }
  };
  const lastJsonMessage = useWebSocket(wsUrl, messageBack);

  const connectToDescriptionSocket = (taskId) => {
    setWsUrl(`wss://ws.marketsandmarkets.com/ws/${taskId}`);
  };

  // useEffect(() => {
  //   const fetchAccounts = async () => {
  //     setLoader(true);
  //     try {
  //       let filter = {
  //         client_code: user?.company_id,
  //       };
  //       const response = await api.get("/accounts/get_accounts", {
  //         params: {
  //           page: 1,
  //           limit: 2000,
  //           ...filter,
  //           is_active: 1,
  //         },
  //       });
  //       const account_result = response?.data?.result?.list ?? [];
  //       const contatc_list = account_result.map(
  //         ({ account_code, account_name }) => ({ account_code, account_name })
  //       );
  //       setAccountoptions(contatc_list);
  //     } catch (err) {
  //       // setError(err.message || 'Failed to fetch accounts');
  //     } finally {
  //       setLoader(false);
  //     }
  //   };

  //   fetchAccounts();
  // }, [user]);

  useEffect(() => {
    setAccountoptions([]);
  }, []);

  const loadUserData = async (selectedOffering = []) => {
    setLoader(true);
    try {
      let is_admin_logged_in = current_role_key === 'CLIENT' ? 1 : 0;
      const requestBody = qs.stringify({ user_id: user?.id, client: user?.company_name, is_admin: is_admin_logged_in });

      const response = await iq_api_v2.post(
        `/user_profile/get_personalisation`,
        requestBody,
        {
          headers: {
            "Accept": "application/json",
            "Content-Type": "application/x-www-form-urlencoded",
          },
        }
      );
      // console.log("RESPONSE: "+JSON.stringify(response));
      const data = response?.data?.result;
      // console.log("RESPONSE: "+JSON.stringify(data));
      const productsByAccount = {};
      // data?.target_geographies = data?.target_geographies.filter()
      if(data?.target_geographies?.length > 0){
        setFormData({
          accounts: data.target_accounts || [],
          geographies: data.target_geographies,
          notification: data.notifications || "",
          useCase: data.use_case || "",
        });
      }else{
        setFormData({
          accounts: data?.target_accounts || [],
          geographies: geographyOptions,
          notification: data?.notifications || "",
          useCase: data?.use_case || "",
        });
      }

      const getAllDocuments = await iq_api_v2.get("/documents/list_documents", {
        params: { user_id: user?.id, client: user?.company_name, document_type: "", is_admin: is_admin_logged_in },
      });
      const documentRes = getAllDocuments?.data?.result.filter((d) => d.document_type === 'offering_level_document');
      setProductDocs(documentRes);
      const verticalRes = getAllDocuments?.data?.result.filter((d) => d.document_type === 'vertical_document');
      setVerticalDocs(verticalRes);
      const globalRes = getAllDocuments?.data?.result.filter((d) => d.document_type === 'global_document');
      setGlobalDocs(globalRes);

      const documents = documentRes || [];

      const offeringList = data.products.map((product) => {
        const relatedDocs = documents.filter(
          (doc) => doc.product_id == product._id
        );

        return {
          name: product.product_name,
          description: product.product_description,
          contactKeywords: product.contact_keywords || [],
          record_id: product._id,
          documents: relatedDocs,
          is_admin: product?.is_admin || 0,
          user_id: product?.user_id || "",
        };
      });

      // console.log("offeringList : ", offeringList)

      setOfferings(offeringList);
      if (offeringList?.length > 0) {
        if(selectedOffering){
          // console.log("SELECTED OFFERING: "+JSON.stringify(selectedOffering));
          let latestOfferingDataIndex = offeringList?.findIndex((offeringItem) => offeringItem.record_id === selectedOffering?.record_id);
          setSelectedOffering(offeringList[latestOfferingDataIndex]);
        }else{
          setSelectedOffering(offeringList?.[0]);
        }
      }

      // Fetch use case documents
      // const useCaseDocRes = await iq_api_v2.get("/documents/list_documents", {
      //   params: {
      //     user_id: user?.id,
      //     client: user?.company_name,
      //     document_type: "use_case_document",
      //     is_admin: is_admin_logged_in
      //   },
      // });

      // const useCaseDocs = useCaseDocRes?.data?.result || [];
      const useCaseDocs = getAllDocuments?.data?.result.filter((d) => d.document_type === 'use_case_document');
      setUseCaseTypeDocs(useCaseDocs);
      const useCaseDocIds = useCaseDocs.map((doc) => doc.record_id);
      // Store document IDs in state
      setUseCaseFileIds(useCaseDocIds);
      setUseCaseDocuments(useCaseDocs);
      // console.log("OFFERING DOCS: "+productDocs?.length+"\nVertical Docs: "+verticalDocs?.length+"\nGLOBAL DOCS: "+globalDocs?.length+"\nUSE CASE DOCS: "+useCaseTypeDocs?.length);
    } catch (error) {
      console.error("Error loading user data:", error);
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    if (user?.id) {
      if(activeTab == 'products'){
        loadUserData(selectedOffering);
      }
    }
  }, [user?.id, activeTab]);

  useEffect(() => {
    if (offerings?.length > 0) {
      setShowOfferingForm(true);
      setShowOfferingUploadForm(false);
      // setSelectedOffering({ name: '', description: '', contactKeywords: [], documents: [] });
    }
  }, [offerings]);

  const fetchFiles = async () => {
    let is_admin_logged_in = current_role_key === 'CLIENT' ? 1 : 0;
    try {
      let res = [];
      if(user?.id){
        res = await iq_api_v2.get("/documents/list_documents", {
          params: {
            user_id: user.id,
            client: user?.company_name,
            document_type: "",
            is_admin: is_admin_logged_in
          },
        });
      }
      // const filtered = res?.data?.result?.filter(file => file.document_type === section);
      setProductDocs(res?.data?.result.filter((d) => d.document_type === 'offering_level_document'));
      setUseCaseTypeDocs(res?.data?.result.filter((d) => d.document_type === 'use_case_document'));
      setVerticalDocs(res?.data?.result.filter((d) => d.document_type === 'vertical_document'));
      setGlobalDocs(res?.data?.result.filter((d) => d.document_type === 'global_document'));
      // setter(res?.data?.result || []);
    } catch (err) {
      console.error(`Error fetching files:`, err);
    }
  };

  useEffect(() => {
    // fetchFiles("Template", setTemplateFiles);
    if(user?.id){
    //  fetchFiles();
    }
  }, [user?.id]);

  if (!appConfig) {
    return <div></div>;
  }

  const toggleDropdown = () => {
    setShowDropdown(!showDropdown);
  };

  const handleUploadOfferingsFormChange = (e) => {
    const { name, value, files, type } = e.target;

    const actualValue = type === "file" ? files[0] : value;

    setUploadOfferingsFormData((prevState) => ({
      ...prevState,
      [name]: actualValue,
    }));

    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: "",
    }));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));

    // Clear the error for the current field
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: "",
    }));
  };

  const validateForm = () => {
    let newErrors = {};

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e, finalOfferings) => {
    if(e && e.preventDefault()) e.preventDefault();

    let offerings_var = [];
    if(!finalOfferings || !finalOfferings.length){
      offerings_var = offerings
    }else{
      offerings_var = finalOfferings
    }
    const payload = new FormData();
    payload.append("user_id", user?.id || "");
    // Ensure it's a string of comma-separated account names
    const targetCompanies = Array.isArray(formData.accounts)
      ? formData.accounts.join(",")
      : "";
    payload.append("target_accounts", targetCompanies);

    // Extract all record_ids from offerings and join
    const allRecordIds = [];
    const contactKeywordsMap = {};
    const documentIdsMap = {};

    let tempOfferings = [];
    if(current_role_key === 'CLIENT_EMPLOYEE'){
      // tempOfferings = offerings_var.filter((offer) => offer.is_admin === 1);
      offerings_var.forEach((offer) => {
        if (offer.is_admin === 0) {
          tempOfferings.push(offer);
        }
      });
      tempOfferings.forEach((off) => {
        if (off.record_id) {
          allRecordIds.push(off.record_id);
          contactKeywordsMap[off.record_id] =
            off.contactKeywords?.join(",") || "";
          documentIdsMap[off.record_id] =
            (off.documents || []).map((doc) => doc.record_id).join(",") || "";
        }
      });
    }else{
      offerings_var.forEach((off) => {
        if (off.record_id) {
          allRecordIds.push(off.record_id);
          contactKeywordsMap[off.record_id] =
            off.contactKeywords?.join(",") || "";
          documentIdsMap[off.record_id] =
            (off.documents || []).map((doc) => doc.record_id).join(",") || "";
        }
      });
    }

    payload.append("client", user?.company_name);
    payload.append("target_offerings", allRecordIds.join(","));
    payload.append(
      "offering_contact_keywords",
      JSON.stringify(contactKeywordsMap)
    );
    payload.append("offering_document_ids", JSON.stringify(documentIdsMap));

    // Ensure geographies are comma-separated
    // console.log("GEOGRAPHIES: "+JSON.stringify(formData.geographies));
    const geographies = Array.isArray(formData.geographies)
      ? formData.geographies.join(",")
      : "";
    payload.append("target_geographies", geographies);

    payload.append("notifications", formData.notification || "");

    payload.append("use_case", formData.useCase);
    // if(formData.useCase.length > 0 && useCaseFileIds.length > 0){
    payload.append(
      "use_case_document_ids",
      (useCaseFileIds).join(",")
    );
    // }

    if(current_role_key === "CLIENT"){
      payload.append("is_admin", 1);
    }else if(current_role_key === "CLIENT_EMPLOYEE"){
      payload.append("is_admin", 0);
    }

    setLoader(true);
    try {
      const response = await iq_api_v2.post(
        "/user_profile/update_personalisation",
        payload,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      // console.log("Submit success:", response.data);
      if (response.data.status === "updated" || response.data.status === "created") {
          setApiSuccess("Profile Updated Successfully !");
          // sessionStorage.setItem('successMessage', response.data.result.message);
          // navigate('/users/upload_documents');
      } else {
            setApiError(response.data.status || 'An error occurred while saving the user.');
      }
      // setApiSuccess("Profile updated successfully !");
      setTimeout(() => {
        setApiSuccess("");
        setApiError("");
      }, 5000);
      loadUserData(selectedOffering);
    } catch (error) {
      console.error("Submit failed:", error);
    }
    setLoader(false);
  };

  const cancelAddingOfferings = () => {
    const newOffering = {
      record_id: null,
      name: "",
      description: "",
      keywords: [],
      files: [],
      file_record_ids: [], // <-- track file IDs per offering
    };
    setErrors((prevErrors) => ({}));
    setSelectedOffering(newOffering);
    setShowOfferingForm(false);
    setShowOfferingUploadForm(false);
  }

  const handleUploadOfferings = async (e) => {
      e.preventDefault();

      const newErrors = {};

      const uploadType = uploadOfferingsFormData?.uploadType || '';
      const uploadFile = uploadOfferingsFormData?.upload_product_file || '';

      if (!uploadType) newErrors.uploadType = "Please select upload type.";
      if (!uploadFile) newErrors.upload_product_file = "Please upload a CSV file.";

      if (Object.keys(newErrors).length > 0) {
        setErrors(newErrors);
        return;
      }

      const formData = new FormData();
      formData.append("client", user.company_name);
      formData.append("user_id", user?.id);
      formData.append("uploaded_by", user?.id);
      formData.append("upload_type", uploadType);
      formData.append("csv_file", uploadFile);

      try {
        const response = await iq_api_v2.post("/admin/upload_products", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });

        // console.log("response : ", response)
        if ((response.status === 200 || response.status === 201) && response?.data?.status == 200 ) {
          setUploadOfferingsFormData({ uploadType: "", upload_product_file: null });
          loadUserData();

          setApiSuccess("Offerings uploaded successfully!");
          setApiError("");

          setTimeout(() => {
            setApiSuccess("");
          }, 5000);
        } else {
          console.warn("Unexpected response:", response);
          let err = response.data.message || ''
          setApiError(err);

          setTimeout(() => {
            setApiError("");
          }, 5000);

        }

      } catch (error) {
        console.error("Upload error:", error);
        setApiError("Error uploading offerings. Please try again.");
      }
  };

  // +++++++++++++++++++++++++++++++++++++++++
  // Add new blank offering
  const handleAddOfferingClick = () => {
    const newOffering = {
      record_id: null,
      name: "",
      description: "",
      keywords: [],
      files: [],
      file_record_ids: [], // <-- track file IDs per offering
    };
    setSelectedOffering(newOffering);
    setShowOfferingForm(true);
    setShowOfferingUploadForm(false);
  };

  const handleUploadOfferingClick = () => {
    const newOffering = {
      record_id: null,
      name: "",
      description: "",
      keywords: [],
      files: [],
      file_record_ids: [], // <-- track file IDs per offering
    };
    setSelectedOffering(newOffering);
    setShowOfferingForm(false);
    setShowOfferingUploadForm(true);
  };

  const removeKeyword = (indexToRemove) => {
    setSelectedOffering((prev) => ({
      ...prev,
      contactKeywords: prev.contactKeywords.filter(
        (_, i) => i !== indexToRemove
      ),
    }));
  };

  // View existing offering
  const handleViewOffering = (offering) => {
    // Clear files and file_record_ids when switching offering
    setSelectedOffering({
      ...offering,
      files: [],
      file_record_ids: [],
    });
    setShowOfferingForm(true)
    setShowOfferingUploadForm(false)
  };

  const handleSaveOffering = async (e) => {
    e.preventDefault();
    const newErrors = {};
    const regex = /^[A-Za-z0-9 ]*$/;
    if (!selectedOffering?.name?.trim()) {
      newErrors.name = "Product name is required";
      // setErrors(newErrors);
      // return false;
    }else if (!regex.test(selectedOffering.name.trim())) {
      newErrors.name = "Product name should not contain special characters.";
    }

    if(selectedOffering?.user_id && selectedOffering.user_id != user?.id){
      setApiError("You can not edit product added by other user");
      setTimeout(() => {
        setApiError("");
      }, 5000);
      return;
    }

    // if (!selectedOffering?.description?.trim()) {
    //   if(!regex.test(selectedOffering?.description?.trim()))
    //     newErrors.description = "Product description should not contain special characters.";
    // }

    if (selectedOffering?.contactKeywords?.length) {
      const invalidKeyword = selectedOffering.contactKeywords.find(
        (kw) => !regex.test(kw)
      );
      if (invalidKeyword) {
        newErrors.contactKeywords = "Keywords should contain only letters and numbers.";
        // setErrors(newErrors);
        // return false;
      }
    }

    setErrors(newErrors);
    if (Object.keys(newErrors).length > 0) return;

    // if (Object.keys(errors).length > 0) return;

    const formData1 = new FormData();
    formData1.append("user_id", user.id);
    formData1.append("client", user.company_name);
    formData1.append("product_name", selectedOffering.name || "");
    formData1.append("product_description", selectedOffering.description || "");
    formData1.append(
      "contact_keywords",
      selectedOffering.contactKeywords?.join(",") || ""
    );
    formData1.append("is_active", "1");

    if (selectedOffering?.record_id) {
      formData1.append("id", selectedOffering.record_id); // for update
    }

    if (selectedOffering.files?.length > 0) {
      selectedOffering.files.forEach((file) => {
        formData1.append("files", file);
      });
    }

    if(current_role_key === "CLIENT"){
      formData1.append("is_admin", 1);
    }else if(current_role_key === "CLIENT_EMPLOYEE"){
      formData1.append("is_admin", 0);
    }

    setLoader(true);
    try {
      const res = await iq_api_v2.post("/user_profile/add_product", formData1, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      const record_id = selectedOffering.record_id || res.data?.record_id;
      if (!record_id) {
        console.error("Failed to get record_id");
        setLoader(false);
        return;
      }

      // ✅ Properly updated offering object
      const updatedOffering = {
        ...selectedOffering,
        record_id,
        is_admin: current_role_key === 'CLIENT' ? 1 : 0,
        user_id: user.id
      };

      // ✅ Update right pane state
      setSelectedOffering(updatedOffering);

      // ✅ Update offerings list (left pane)
      setOfferings((prev) => {
        const idx = prev.findIndex((o) => o.record_id === record_id);
        if (idx !== -1) {
          const updated = [...prev];
          updated[idx] = updatedOffering;
          return updated;
        } else {
          return [...prev, updatedOffering];
        }
      });

      // ✅ Small delay before submit
      await wait(3000);

      // ✅ Submit updated offerings to parent or API
      let updated_offerings = [...offerings.filter(o => o.record_id !== record_id), updatedOffering].filter((data => data?.user_id == user.id ))
      
      // console.log("updated_offerings :: ", updated_offerings)
      // return false;

      handleSubmit(null, updated_offerings);
    } catch (err) {
      console.error("Failed to save offering:", err);
    }
    setLoader(false);
  };

  const wait = (ms) => new Promise(resolve => setTimeout(resolve, ms));


  const handleGenerateDescription = async () => {
    if (
      !selectedOffering?.name ||
      !user?.company_name
      // || formData.accounts.length === 0
    ) {
      setErrors("Offering name, client, and account are required.");
      return;
    }

    const requestPayload = qs.stringify({
      offering: selectedOffering.name,
      client: user?.company_name,
      account: "",
    });
    setIsGenerating(true);
    try {
      const { data } = await iq_api_v2.post(
        "/user_profile/get_offering_description?" + requestPayload
      );

      const taskId = data?.task_id;
      if (!taskId) {
        setApiError("Failed to get task ID.");
        return;
      }

      // Connect to WebSocket for the generated description
      connectToDescriptionSocket(taskId);
      // setIsGenerating(false);
    } catch (error) {
      console.error("Failed to trigger description generation:", error);
      setErrors("Failed to generate description.");
      setIsGenerating(false);
    }
  };

  const handleFileUpload = async (files) => {
    if (!selectedOffering || files.length === 0) return;

    let offeringRecordId = selectedOffering.record_id;
    setLoader(true);

    // Step 1: Create offering if it doesn't exist
    if (!offeringRecordId) {
      try {
        const createForm = new URLSearchParams();
        createForm.append("user_id", user.id);
        createForm.append("client", user.company_name);
        createForm.append("product_name", selectedOffering.name);
        createForm.append(
          "product_description",
          selectedOffering.description || ""
        );
        createForm.append("contact_keywords", selectedOffering.keywords || "");
        createForm.append("is_active", 1);
        if(current_role_key === "CLIENT"){
          createForm.append("is_admin", 1);
        }else if(current_role_key === "CLIENT_EMPLOYEE"){
          createForm.append("is_admin", 0);
        }

        const createRes = await iq_api_v2.post(
          "/user_profile/add_product",
          createForm,
          {
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
          }
        );

        offeringRecordId = createRes.data?.record_id;
        if (!offeringRecordId) throw new Error("Failed to create offering");

        // Update state with new record ID
        setSelectedOffering((prev) => ({
          ...prev,
          record_id: offeringRecordId,
        }));

        setOfferings((prev = []) => {
          const existingIdx = prev?.findIndex(
            (o) => o.name === selectedOffering.name
          );
          const updatedOffering = {
            ...selectedOffering,
            record_id: offeringRecordId,
          };
          if (existingIdx > -1) {
            const copy = [...prev];
            copy[existingIdx] = updatedOffering;
            return copy;
          }
          return [...prev, updatedOffering];
        });
      } catch (err) {
        console.error("Offering creation failed", err);
        setLoader(false);
        return;
      }
    }

    // Step 2: Upload each file one by one
    const allUploadedFileIds = [];
    for (const file of files) {
      const formData2 = new FormData();
      formData2.append("user_id", user.id);
      formData2.append("client", user?.company_name);
      formData2.append("product_id", offeringRecordId);
      formData2.append("document_type", "offering_level_document");
      formData2.append("file", file);
      let is_admin_logged_in = current_role_key === 'CLIENT' ? 1 : 0;
      formData2.append("is_admin", is_admin_logged_in);
      try {
        const uploadResponse = await iq_api_v2.post(
          "/documents/upload_file",
          formData2,
          {
            headers: { "Content-Type": "multipart/form-data" },
          }
        );

        const fileId = uploadResponse?.data?.result?.record_id;
        if (fileId) {
          allUploadedFileIds.push(fileId);
        } else {
          console.warn("No file ID returned for a file.");
        }
      } catch (err) {

        setApiError("Failed to upload file. "+(err?.response?.data?.detail || ""));

        console.error("File upload failed for", file.name, err);
      }
    }

    if (allUploadedFileIds.length === 0) {
      setLoader(false);
      console.warn("No files uploaded.");
      return;
    }else{
      setApiSuccess("File/Files uploaded successfully, kindly save profile now");
      setTimeout(() => {
        setApiSuccess("");
      }, 3000);
    }

    // Step 3: Create memory
    const memoryPayload = {
      prompt: "create a summary from this document",
      user_id: user?.id,
      client: user?.company_name,
      offering_name: selectedOffering?.name,
      memory_type: "offering",
      tag_name: "",
      file_ids: allUploadedFileIds.join(","),
      ...(current_role_key === "CLIENT" ? { is_admin: 1 } : { is_admin: 0 }),
    };

    const urlEncodedPayload = new URLSearchParams(memoryPayload).toString();
    try {
      await iq_api_v2.post("/build_memory/create_memory", urlEncodedPayload, {
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
      });
    } catch (err) {
      console.error("Create memory API failed", err);
    }

    // Step 4: Final offering update (without file ids)
    const updateForm = new URLSearchParams();
    updateForm.append("user_id", user.id);
    updateForm.append("client", user.company_name);
    updateForm.append("id", offeringRecordId);
    updateForm.append("product_name", selectedOffering.name);
    updateForm.append(
      "product_description",
      selectedOffering.description || ""
    );
    updateForm.append("contact_keywords", selectedOffering.keywords || "");
    updateForm.append("is_active", 1);
    if(current_role_key === "CLIENT"){
      updateForm.append("is_admin", 1);
    }else if(current_role_key === "CLIENT_EMPLOYEE"){
      updateForm.append("is_admin", 0);
    }

    try {
      const res = await iq_api_v2.post(
        "/user_profile/add_product",
        updateForm,
        {
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
        }
      );

      const newRecordId = res.data?.record_id || offeringRecordId;
      setSelectedOffering((prev) => ({
        ...prev,
        record_id: newRecordId,
        files: [...(prev.files || []), ...Array.from(files)],
      }));

      setOfferings((prev) => {
        const idx = prev?.length > 0 && prev?.findIndex((o) => o.record_id === newRecordId);
        const updatedOffering = {
          ...(idx > -1 ? prev[idx] : selectedOffering),
          record_id: newRecordId,
          files: [...(selectedOffering.files || []), ...Array.from(files)],
        };
        if (idx > -1) {
          const copy = [...prev];
          copy[idx] = updatedOffering;
          return copy;
        }
        return [...prev, updatedOffering];
      });
    } catch (err) {
      console.error("Add product API (final update) failed", err);
    }

    setLoader(false);
      // Clear input after upload
  if (fileInputRef.current) {
    fileInputRef.current.value = "";
  }
  };
  // [END] => HANDLE FILE UPLOAD

  //[Start] => Use Case File Upload Handler
  const handleUseCaseFileUpload = async (files) => {
    if (!formData.useCase || files.length === 0) return;
  
    setLoader(true);
  
    const formDataUpload = new FormData();
    formDataUpload.append("user_id", user.id);
    formDataUpload.append("client", user.company_name);
    formDataUpload.append("document_type", "use_case_document");

    let is_admin_logged_in = current_role_key === 'CLIENT' ? 1 : 0;
    formDataUpload.append("is_admin", is_admin_logged_in);

    for (let file of files) {
      formDataUpload.append("file", file);
    }
  
    try {
      const uploadRes = await iq_api_v2.post("/documents/upload_file", formDataUpload, {
        headers: { "Content-Type": "multipart/form-data" },
      });
  
      const fileIds = uploadRes?.data?.result?.record_id || [];
      const fileIdsArr = Array.isArray(fileIds) ? fileIds : [fileIds];
  
      if (fileIdsArr.length === 0) {
        console.warn("No file IDs returned, skipping memory creation");
        return;
      }else{
        setApiSuccess("File/Files uploaded successfully, kindly save profile now");
        setTimeout(() => {
          setApiSuccess("");
        }, 3000);
      }

      setUseCaseFileIds(fileIdsArr);
      const memoryPayload = {
        prompt: "create a summary from this document",
        user_id: user?.id,
        client: user?.company_name,
        memory_type: "use_case",
        use_case_name: formData.useCase,  // ✅ send key, not label
        tag_name: "",
        file_ids: fileIdsArr.join(","),
        ...(current_role_key === "CLIENT" ? { is_admin: 1 } : { is_admin: 0 }),
      };
  
      const encodedPayload = new URLSearchParams(memoryPayload).toString();
  
      await iq_api_v2.post("/build_memory/create_memory", encodedPayload, {
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
      });
    } catch (err) {
      console.error("Use case file upload or memory creation failed", err);
    } finally {
      setLoader(false);
    }
  };
  
  //[End] => Use Case File Upload Handler

  const handleDeleteOffering = async (record_id) => {
    try {
      await iq_api_v2.post(
        "/user_profile/delete_product",
        new URLSearchParams({
          record_id,
          user_id: user.id,
          client: user.company_id,
        }),
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        }
      );

      // Remove from state
      setOfferings((prev) => prev.filter((off) => off.record_id !== record_id));

      // Optional: if currently selected, clear form
      if (selectedOffering?.record_id === record_id) {
        setSelectedOffering(null);
      }
    } catch (error) {
      console.error("Failed to delete offering", error);
      setApiError("Failed to delete offering. Please try again.");
    }
  };

  const handleDeleteProdct = async(user_id, record_id) => {
    setCurrentDeletingInfo({'record_id': record_id, 'user_id': user_id})
  }

  const downloadFile = async (recordId, filename) => {
    try {
      const response = await iq_api_v2.get("/documents/download_file/", {
        params: { record_id: recordId },
        responseType: "blob", // Important for binary data
      });
  
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", filename || "document");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Download failed:", error);
    }
  };
  // +++++++++++++++++++++++++++++++++++++++++

  // $$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$

  const uploadFile = async (file, section, refresh) => {
    const formData3 = new FormData();
    formData3.append("user_id", user?.id);
    formData3.append("client", user?.company_name);
    formData3.append("file", file);

    let doc_type = 'global_document';

    if(memoryType === 'vertical'){
      doc_type = 'vertical_document';
    }else if(memoryType === 'use_case'){
      doc_type = 'use_case_document';
    }else{
      doc_type = 'global_document';
    }
    formData3.append("document_type", doc_type);
    let is_admin_logged_in = current_role_key === 'CLIENT' ? 1 : 0;
    formData3.append("is_admin", is_admin_logged_in);

    try {
      const response = await iq_api_v2.post("/documents/upload_file", formData3, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      refresh();

      if (response?.data?.status === 400 || response?.data?.status === 401) {
        setApiError("Unsupported file type");
      } else {
        // +++++++++++++++++++++++++++++
        const DocIds = response?.data?.result?.record_id || [];
        const DocIdsArr = Array.isArray(DocIds) ? DocIds : [DocIds];

        if (DocIdsArr.length === 0) {
          console.warn("No file IDs returned, skipping memory creation");
          return;
        }

        const memoryPayload = {
          prompt: "create a summary from this document",
          user_id: user?.id,
          client: user?.company_name,
          memory_type: "global",
          tag_name: "",
          file_ids: DocIdsArr.join(","),
          ...(current_role_key === "CLIENT" ? { is_admin: 1 } : { is_admin: 0 }),
        };

        const encodedPayload = new URLSearchParams(memoryPayload).toString();

        await iq_api_v2.post("/build_memory/create_memory", encodedPayload, {
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
        });
        // +++++++++++++++++++++++++++++
        setApiSuccess("File uploaded successfully!");
      }
    } catch (err) {
      setApiError("Couldn't upload file, please try again later");
    }

    setTimeout(() => {
      setApiSuccess("");
      setApiError("");
    }, 5000);
  };

  const handleDocFileChange = (event, section, setter) => {
    const file = event.target.files[0];
    if (file) {
      uploadFile(file, section, () => fetchFiles());
      event.target.value = ""; // reset file input
    }
  };

  const deleteFile = async (id) => {
    let delete_response = [];
    let msg = "";
    try {
      const deleteRequestBody = new FormData();
      deleteRequestBody.append('record_id', id)
      delete_response = await iq_api_v2.delete(`/documents/delete_template_file?record_id=`+id)
      //   deleteRequestBody,
      //   {
      //     headers: {
      //       "Accept": "application/json",
      //       "Content-Type": "application/x-www-form-urlencoded",
      //     },
      //   }
      // );

      // refresh(); // Refresh after delete
      if(delete_response?.data?.status == 400 || delete_response?.data?.status == 401){
        setApiError("Couldn't delete file, please try again later");
        setTimeout(() => {
          setApiError("");
          msg = "";
        }, 5000);
      }else{
        loadUserData();
        setApiSuccess("File deleted successfully !")
        setTimeout(() => {
          setApiSuccess("");
        }, 5000);
      }
      // fetchFiles("Template", setTemplateFiles);
    } catch (err) {
      // console.error("Delete failed:", err);
      setApiError("Couldn't delete file, please try again later");
      setTimeout(() => {
        setApiError("");
      }, 5000);
    }
  };

  const INDUSTRIES = [
    "Automation",
    "Aerospace & Defence",
    "Agriculture",
    "Automotive & Transportation",
    "BFSI",
    "Chemicals & Material",
    "Consulting",
    "Energy & Power",
    "Food & Beverage",
    "Healthcare",
    "Information & Communications Technology",
    "Packaging, Construction, Mining & Gases",
    "Semiconductor & Electronics",
  ];

  const handleDocTabChange = (tab = 'products') => {
    setActiveDocTab(tab);
  }

  const confirmDelete = async() => {

    const record_id = currentDeletingInfo?.record_id;
    const user_id = currentDeletingInfo?.user_id;

    if(selectedOffering?.record_id == record_id){
      setShowOfferingForm(false);
      setSelectedOffering({})
    }

    const delete_response = await iq_api_v2.delete(`/user_profile/delete_product`, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        data: new URLSearchParams({
          product_id: record_id,
          user_id: user_id
        }).toString()
    });

    if(delete_response?.status == 200 && delete_response?.data?.product_id){
      const new_offerings = offerings.filter(e => e.record_id != record_id)
      setOfferings(new_offerings)
    }
    setCurrentDeletingInfo({});
  };

  const hideDeleteConfirm = () => {
    setCurrentDeletingInfo({})
  };

  const renderTable = (data) => {
    return (data &&
      <div className="table_doc_block">
        <div className="table-responsive">
          <table className="table_doc">
            <thead>
              <tr className="table_doc_th">
                <th className="table_doc_th">Document Name</th>
                <th className="table_doc_th">Impact Areas</th>
                <th className="table_doc_th">Upload Date</th>
                <th className="table_doc_th"></th>
                {/* <th className="table_doc_th"></th> */}
              </tr>
            </thead>
            <tbody className="table_doc_tbody">
              {data.length === 0 ? (
                <tr className="table_doc_tr">
                  <td className="table_doc_td" colSpan={3} style={{textAlign: 'center'}}>
                    No documents found
                  </td>
                </tr>
              ) : (
                data.map((doc, idx) => (
                  <tr className="table_doc_tr" key={idx}>
                    <td className="table_doc_td"
                      style={{
                        minHeight: "250px",
                        minWidth: "250px"
                      }}
                    >
                      <span style={{
                        padding: "5px",
                        backgroundColor: "#F7FBFF",
                        color: "#515457",
                        border: "0.5px solid #CED7F3",
                        fontFamily: "Inter",
                        fontWeight: "500",
                        borderRadius: "6px",
                        fontSize: "11px",
                        lineHeight: "13.75px",
                        verticalAlign: "middle",
                      }}>
                        <img src="/img/blueDocIcon.png" width="16"></img>
                        {doc?.filename || ""}
                      </span>
                    </td>
                    <td className="table_doc_td">{doc?.impact_areas || ""}</td>
                    <td className="table_doc_td">
                      {
                        // doc.modified_date || ""
                        doc?.modified_date && displayFormattedDate(
                          doc?.modified_date,
                          "YYYY-MM-DD",
                          true)
                      }
                    </td>
                    <td className="table_doc_td" style={{textAlign: "end"}}>
                      {current_role_key === 'CLIENT_EMPLOYEE' && doc?.is_admin === 1 && (
                      <i title="Document uploaded by admin">
                        <FeatherIcon.Lock style={{width: "16px", height: "16px"}} className='img_trend' />
                      </i>)}
                      {user?.id === doc?.user_id && (<><i
                        onClick={() =>
                          downloadFile(
                            doc._id,
                            doc.filename
                          )
                        }
                        title="Click to download"
                      >
                        <FeatherIcon.Download
                          style={{
                            width: "16px",
                            height: "16px",
                            padding: "1px",
                            cursor: "pointer"
                          }}
                          className='img_trend ml-2'
                        />
                      </i>

                      <i
                        onClick={() =>
                          deleteFile(
                            doc._id,
                          )
                        }
                        title="Click to delete"
                      >
                        <FeatherIcon.Trash2
                          style={{
                            width: "16px",
                            height: "16px",
                            padding: "1px",
                            cursor: "pointer"
                          }}
                          className='img_trend ml-2'
                        />
                      </i></>)}
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    )
  };

  const handleMemoryModalClose = () => {
    setShowMemoryModal(false);
    setMemoryType('global');
    setSubType("");
    setSelectedFile(null);
  }

  const MemoryModal = () => (
    <div className={`modal fade ${showMemoryModal ? 'show d-block' : ''}`} tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Add Document</h5>
            <button type="button" className="btn-close" onClick={handleMemoryModalClose}></button>
          </div>
          <div className="modal-body">
            {/* -- memory_type select -- */}
            <div className="mb-3">
              <span className="target_head mb-2">Memory Type</span>
              <select
                className="form-select offering_form_input mt-2"
                value={memoryType}
                onChange={
                  e => {
                    setMemoryType(e.target.value);
                    setSubType("");
                    setSelectedFile(null);
                    setMemoryTypeError("");
                  }
                }
              >
                <option value="global">Global</option>
                <option value="vertical">Vertical</option>
                <option value="use_case">Use Case</option>
              </select>
            </div>

            {/* -- Subtype dropdown if not global -- */}
            {memoryType !== "global" && (
              <div className="mb-3">
                <span className="target_head mb-2">
                  {memoryType === "vertical" ? "Vertical Name" : "Use Case Name"}
                </span>
                <select
                  className="form-select offering_form_input mt-2"
                  name={memoryType === 'vertical' ? 'vertical' : 'use_case'}
                  value={subType}
                  onChange={
                    (e) => {
                      setSubType(e.target.value)
                      setSelectedFile(null);
                      setMemoryTypeError("");
                    }
                  }
                >
                  <option value="">Select {memoryType === "vertical" ? "Vertical" : "Usecase"}</option>
                  { memoryType === 'vertical' ? (INDUSTRIES.map((industry) => (
                    <option key={industry} value={industry}>
                      {industry}
                    </option>
                  ))) :
                  (Object.keys(useCaseOptions).map(
                    (key) => (
                      <option
                        key={`usecase-${key}`}
                        value={key}
                      >
                        {useCaseOptions[key]}
                      </option>
                    )
                  )) }
                </select>
                {memoryTypeError.length > 0 && <span className="text-danger">
                  {memoryTypeError}
                </span>}
              </div>
            )}

            {/* -- File Upload -- */}
            <div className="mb-3">
              <span className="target_head mb-2">Choose File</span>
              <input
                type="file"
                className="form-control offering_form_input mt-2"
                // onChange={(e) => setSelectedFile(e.target.files[0])}
                onChange={(e) => {
                  const file = e.target.files[0];
                  setSelectFileError("");
                  if (file) setSelectedFile(file);
                }}
              />
              {selectedFile && (
                <div className="mt-2">
                  <span style={{ fontStyle: "italic", fontSize: "0.9rem" }}>
                    Selected: {selectedFile.name}
                  </span>
                </div>
              )}
              {selectFileError.length > 0 && <span className="text-danger">
                {selectFileError}
              </span>}
            </div>
          </div>
          <div className="modal-footer">
            <button className="btn btn-secondary" onClick={handleMemoryModalClose}>Cancel</button>
            <button className="personalisation_button btn btn-primary btn-sm" onClick={(e) => handleUploadAndCreateMemory(e)}>Add Document</button>
          </div>
        </div>
      </div>
    </div>
  );

  const handleUploadAndCreateMemory = async (e) => {
    e.preventDefault();

    if(memoryType === 'vertical' || memoryType === 'use_case'){
      if(!subType){
        // alert(`Kindly select ${memoryType.replace(/_/g, " ")} name`);
        if(memoryType === 'vertical')
          setMemoryTypeError("Kindly select a vertical name!");
        else
          setMemoryTypeError("Kindly select a use case name!");
        return;
      }
    }

    if (!selectedFile) {
      // alert("Please select a file.");
      setSelectFileError("Kindly select a file to upload!");
      return;
    }else{
      setShowMemoryModal(false);
    }

    const formData4 = new FormData();
    formData4.append("user_id", user?.id);
    formData4.append("client", user?.company_name);
    formData4.append("file", selectedFile);

    let doc_type = 'global_document';

    if(memoryType === 'vertical'){
      doc_type = 'vertical_document';
    }else if(memoryType === 'use_case'){
      doc_type = 'use_case_document';
    }else{
      doc_type = 'global_document';
    }
    formData4.append("document_type", doc_type);
    let is_admin_logged_in = current_role_key === 'CLIENT' ? 1 : 0;
    formData4.append("is_admin", is_admin_logged_in);
    setLoader(true);
    try {
      const response = await iq_api_v2.post("/documents/upload_file", formData4, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      // refreshFn();

      const DocIds = response?.data?.result?.record_id || [];
      const DocIdsArr = Array.isArray(DocIds) ? DocIds : [DocIds];

      if (DocIdsArr.length === 0) {
        console.warn("No file IDs returned, skipping memory creation");
        return;
      }

      const memoryPayload = {
        prompt: "create a summary from this document",
        user_id: user?.id,
        client: user?.company_name,
        memory_type: memoryType,
        tag_name: "",
        file_ids: DocIdsArr.join(","),
        ...(current_role_key === "CLIENT" ? { is_admin: 1 } : { is_admin: 0 }),
        ...(memoryType === "use_case" && { use_case_name: subType }),
        ...(memoryType === "vertical" && { vertical_name: subType }),
      };
      const encodedPayload = new URLSearchParams(memoryPayload).toString();

      await iq_api_v2.post("/build_memory/create_memory", encodedPayload, {
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
      });

      setApiSuccess("Document uploaded successfully!");
      setShowMemoryModal(false);
      setSelectedFile(null);
      setSubType("");
      setMemoryType("global");
      loadUserData();
    } catch (err) {
      setApiError("Upload or memory creation failed. Try again.");
    }
    setLoader(false);
    setTimeout(() => {
      setApiSuccess("");
      setApiError("");
    }, 5000);
  };
  // $$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$

  return (
    <>
      <div className="user_profile_wrapper">
        {loader === true && <ScreenLoader />}
        <div className="container-fluid">
          <div className="user_profile_subblock">
            <div className="row">
              {/* <div className="client_head_left">
                <h5 className="client_head">Client admin login</h5>
              </div> */}
              <div
                className="col-md-2"
                style={{ borderRight: "solid 0.1rem #98A4AA33" }}
              >
                <div className="sidebar_profile">
                  <UserPreferenceSidebar />
                </div>
              </div>
              <div className="col-md-10 pl-0">
                <div
                  className="userprofile_right p-0"
                  style={{ border: "none" }}
                >
                  {/* ####################################### */}
                  {/* [START] => UPPER TABS */}
                  <div className="navbar navbar-expand-lg container-fluid custom_subnavbar" style={{zIndex: "0"}}>
                    <ul className="nav nav-tabs custom_nav_tab">
                      <li className="nav-item">
                        <a
                          className={`nav-link ${
                            activeTab === "products" ? "active" : ""
                          }`}
                          onClick={() => {
                              setActiveTab("products");
                              setSelectedOffering(offerings?.[0] || []);
                            }
                          }
                        >
                          Products
                        </a>
                      </li>

                      {current_role_key === 'CLIENT' && <li className="nav-item">
                        <a
                          className={`nav-link ${
                            activeTab === "accounts" ? "active" : ""
                          }`}
                          onClick={() => setActiveTab("accounts")}
                        >
                          Accounts
                        </a>
                      </li>}

                      {current_role_key === 'CLIENT' && <li className="nav-item">
                        <a
                          className={`nav-link ${
                            activeTab === "users" ? "active" : ""
                          }`}
                          onClick={() => setActiveTab("users")}
                        >
                          Users
                        </a>
                      </li>}


                      {/* will uncomment later */}
                     {current_role_key === 'CLIENT' && <li className="nav-item">
                        <a
                          className={`nav-link ${
                            activeTab === "preferences" ? "active" : ""
                          }`}
                          onClick={() => setActiveTab("preferences")}
                        >
                          Preferences
                        </a>
                      </li>}
                      {current_role_key === 'CLIENT' && 
                      <li className="nav-item">
                        <a
                          className={`nav-link ${
                            activeTab === "documents" ? "active" : ""
                          }`}
                          onClick={() => setActiveTab("documents")}
                        >
                          Documents
                        </a>
                      </li>
                      }

                      {current_role_key === 'CLIENT' && <li className="nav-item">
                        <a
                          className={`nav-link ${
                            activeTab === "contact_settings" ? "active" : ""
                          }`}
                          onClick={() => setActiveTab("contact_settings")}
                        >
                          Contact
                        </a>
                      </li>}

                      {current_role_key === 'CLIENT' && <li className="nav-item">
                        <a
                          className={`nav-link ${
                            activeTab === "signals" ? "active" : ""
                          }`}
                          onClick={() => setActiveTab("signals")}
                        >
                          Signals
                        </a>
                      </li>}
                       {
                        isAuthorized && <li className="nav-item">
                        <a
                          className={`nav-link ${
                            activeTab === "auto_nurture" ? "active" : ""
                          }`}
                          onClick={() => setActiveTab("auto_nurture")}
                        >
                          Auto Nurture
                        </a>
                      </li>
                      } 
                      
                    </ul>
                  </div>
                  {/* [END] => UPPER TABS */}

                  {/* [START] => ALERTS PART */}
                  {apiError && <Alert type="danger" message={apiError} />}
                  {apiSuccess && (
                    <Alert type="success" message={apiSuccess} />
                  )}
                  {/* [END] => ALERTS PART */}
                  {/* ####################################### */}

                  <div className="row container-fluid">
                    <div className="col-md-12">
                      <Form
                        onSubmit={(e) => handleSubmit(e)}
                        // className="user_form_info"
                        className={`user_form_info ${activeTab === "accounts" || activeTab === "users" || activeTab === "contact_settings" || activeTab === "signals" ? 'd-none' : '' }  ` }
                        autoComplete="off"
                      >
                        {/* <div className="row"> */}
                          {activeTab === "preferences" && (
                            <div className="row">
                              {/* [START] => TARGET ACCOUNTS */}
                              {/* <div className="col-12">
                                <div className="form-control-info offering_custom_card_block">
                                  <span className="target_head">
                                    Target Accounts
                                  </span>
                                  <Multiselect
                                    name="accounts"
                                    style={{
                                      multiselectContainer: {
                                        height: "auto",
                                        overflow: "visible",
                                      },
                                    }}
                                    options={accountOptions.map((value) => ({
                                      id: value.account_code,
                                      name: value.account_name,
                                    }))}
                                    selectedValues={accountOptions
                                      .filter((value) =>
                                        formData.accounts.includes(
                                          value.account_code
                                        )
                                      )
                                      .map((value) => ({
                                        id: value.account_code,
                                        name: value.account_name,
                                      }))}
                                    onSelect={(selectedList) => {
                                      const selectedValues = selectedList.map(
                                        (item) => item.id
                                      );
                                      setFormData((prev) => ({
                                        ...prev,
                                        accounts: selectedValues,
                                      }));
                                    }}
                                    onRemove={(selectedList) => {
                                      const selectedValues = selectedList.map(
                                        (item) => item.id
                                      );
                                      setFormData((prev) => ({
                                        ...prev,
                                        accounts: selectedValues,
                                      }));
                                    }}
                                    displayValue="name"
                                    showCheckbox={true}
                                    placeholder="Select Accounts"
                                  />
                                  {errors?.accounts && (
                                    <div className="text-danger custom_error_msg">
                                      {errors.accounts}
                                    </div>
                                  )}
                                </div>
                              </div> */}
                              {/* [END] => TARGET ACCOUNTS */}

                              {/* [START] => TARGET GEOGRAPHIES */}
                              <div className="col-6 pr-2 d-inline-block">
                                <div className="form-control-info offering_custom_card_block" style={{
                                  marginTop: 0,
                                }}>
                                  <span className="target_head">
                                    Target Geographies
                                  </span>
                                  <Multiselect
                                    name="geographies"
                                    value={formData?.geographies || []}
                                    options={geographyOptions.map((value) => ({
                                      id: value,
                                      name: value,
                                    }))}
                                    selectedValues={geographyOptions
                                      .filter((value) =>
                                        formData.geographies.includes(value)
                                      )
                                      .map((value) => ({
                                        id: value,
                                        name: value,
                                      }))}
                                    onSelect={(selectedList) => {
                                      const selectedValues = selectedList.map(
                                        (item) => item.id
                                      );
                                      setFormData((prev) => ({
                                        ...prev,
                                        geographies: selectedValues,
                                      }));
                                    }}
                                    onRemove={(selectedList) => {
                                      const selectedValues = selectedList.map(
                                        (item) => item.id
                                      );
                                      setFormData((prev) => ({
                                        ...prev,
                                        geographies: selectedValues,
                                      }));
                                    }}
                                    displayValue="name"
                                    showCheckbox={true}
                                    placeholder="Select Geography"
                                  />
                                </div>
                                {errors.geographies && (
                                  <div className="text-danger custom_error_msg pt-2 px-2">
                                    {errors.geographies}
                                  </div>
                                )}
                              </div>
                              {/* [END] => TARGET GEOGRAPHIES */}

                              {/* [START] => NOTIFICATION FREQUENCY */}
                              <div className="col-6 d-inline-block">
                                <div className="form-control-info offering_custom_card_block" style={{
                                  marginTop: 0,
                                }}>
                                  <span className="target_head">
                                    Notifications
                                  </span>
                                  <Form.Control
                                    className="form-input1 notification_input"
                                    as="select"
                                    placeholder="Select Notification Frequency"
                                    name="notification"
                                    style={{
                                      paddingLeft: "15px",
                                      zIndex: "unset",
                                    }}
                                    value={formData.notification}
                                    onChange={handleChange}
                                  >
                                    <option key="" value="">
                                      Select Notification Frequency
                                    </option>
                                    {Object.keys(notificationOptions).map(
                                      (key) => (
                                        <option
                                          key={`notification-${key}`}
                                          value={key}
                                        >
                                          {notificationOptions[key]}
                                        </option>
                                      )
                                    )}
                                  </Form.Control>
                                </div>
                                {errors.notification && (
                                  <div className="text-danger custom_error_msg pt-2 px-2">
                                    {errors.notification}
                                  </div>
                                )}
                              </div>
                              {/* [END] => NOTIFICATION FREQUENCY */}

                              {/* [START] => SEPARATE MEMORY CREATION */}
                              <div className="col-12">
                                <div className="form-control-info offering_custom_card_block">
                                  <div className="col-6 pr-2 d-inline-block">
                                    <span className="target_head">
                                      Use Case
                                    </span>
                                    <Form.Control
                                      className="form-input1 notification_input"
                                      as="select"
                                      name="useCase"
                                      value={formData.useCase}
                                      onChange={handleChange}
                                      style={{
                                        paddingLeft: "15px",
                                        zIndex: "unset",
                                      }}
                                    >
                                      <option key="" value="">
                                        Select Use Case
                                      </option>
                                      {Object.keys(useCaseOptions).map(
                                        (key) => (
                                          <option
                                            key={`usecase-${key}`}
                                            value={key}
                                          >
                                            {useCaseOptions[key]}
                                          </option>
                                        )
                                      )}
                                    </Form.Control>
                                  </div>

                                  <div className="col-6 mt-2 d-inline-block">
                                    <Form.Group className="pt-2">
                                      <span className="target_head">
                                        Upload Files
                                      </span>
                                      <Form.Control
                                        type="file"
                                        className="offering_form_input"
                                        multiple
                                        style={{ marginTop: "0px" }}
                                        onChange={(e) =>
                                          handleUseCaseFileUpload(
                                            e.target.files
                                          )
                                        }
                                      />
                                    </Form.Group>
                                  </div>
                                  {useCaseDocuments?.length > 0 && (
                                    <div className="mt-3 mb-3">
                                      <span className="target_head">
                                        Uploaded Use Case Documents:
                                      </span>
                                      <div className="d-flex flex-wrap gap-2 mt-2">
                                        {useCaseDocuments.map((doc) => (
                                          ((current_role_key === 'CLIENT_EMPLOYEE' && doc?.is_admin === 0) || (current_role_key === 'CLIENT')) && <span
                                            key={doc._id}
                                            className="badge bg-secondary offering_document_view_download"
                                          >
                                            {doc.filename}
                                            {user?.id === doc?.user_id && (<><i
                                              onClick={() =>
                                                downloadFile(
                                                  doc._id,
                                                  doc.filename
                                                )
                                              }
                                              title="Click to download"
                                            >
                                              <FeatherIcon.Download
                                                style={{
                                                  width: "16px",
                                                  height: "16px",
                                                  padding: "1px",
                                                  cursor: "pointer"
                                                }}
                                                className='img_trend ml-2'
                                              />
                                            </i>

                                            <i
                                              onClick={() =>
                                                deleteFile(
                                                  doc._id,
                                                )
                                              }
                                              title="Click to delete"
                                            >
                                              <FeatherIcon.Trash2
                                                style={{
                                                  width: "16px",
                                                  height: "16px",
                                                  padding: "1px",
                                                  cursor: "pointer"
                                                }}
                                                className='img_trend ml-2'
                                              />
                                            </i></>)}
                                          </span>
                                        ))}
                                      </div>
                                    </div>
                                  )}
                                </div>
                              </div>
                              {/* [END] => SEPARATE MEMORY CREATION */}
                            </div>
                          )}
                        {/* </div> */}
                        <div className="row">
                          {/* +++++++++++++++++++++++++++++++++++++++++++++ */}
                          {/* [START] => TARGET OFFERING SECTION */}
                          {activeTab === "products" && (
                            <div className="">
                              <div className="row offering_custom_card_block p-0">
                                {/* [START] => TARGET OFFERING TABLE */}
                                <div className="d-flex align-items-center justify-content-between pt-3">
                                  <div className="d-inline-block">
                                    <h5 className="target_head mb-0">
                                      Target Products
                                    </h5>
                                  </div>
                                  <div className="d-inline-block float-end">
                                    {( current_role_key != 'ANALYST' && (showOfferingForm || !showOfferingUploadForm || selectedOffering?.record_id)) && <Button
                                      size="sm mr-2"
                                      onClick={handleAddOfferingClick}
                                      className="personalisation_button"
                                    >
                                      Add Products
                                    </Button>
                                    }

                                    {( current_role_key != 'ANALYST' && (showOfferingUploadForm || !showOfferingForm || selectedOffering?.record_id)) && <Button
                                      size="sm"
                                      onClick={handleUploadOfferingClick}
                                      className="personalisation_button"
                                    >
                                      Upload Products
                                    </Button>
                                    }
                                  </div>
                                </div>

                                <div className="col-md-3 pr-0 pl-0" style={{ minHeight: '500px', height: "auto", overflowY: "auto"}}>
                                  <div className="form-control-info">

                                    <Table
                                      bordered
                                      hover
                                      responsive
                                      size="sm"
                                      className="offering_table"
                                    >
                                      <thead className="d-none">
                                        <tr>
                                          <th className="offering_table_header">
                                            Product Name
                                          </th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {offerings?.length > 0 && offerings.map((offering, index) => (
                                          <tr
                                            key={offering.record_id}
                                          >
                                            <td
                                              className={`w-75 offering_table_td offering_name_effect ${
                                                selectedOffering?.name ===
                                                offering.name
                                                  ? "highlight_offering"
                                                  : ""
                                              }`}
                                              onClick={() =>
                                                handleViewOffering(offering)
                                              }
                                            >
                                                {offering.name}
                                            </td>

                                            
                                            <td className="w-75">
                                              {offering.user_id && offering.user_id == user?.id && 
                                                <span 
                                                className={`${currentDeletingInfo?.record_id != "" && offering.record_id == currentDeletingInfo?.record_id ? '': 'cursorP'}`}
                                                style={{
                                                  cursor: currentDeletingInfo?.record_id != "" && offering.record_id == currentDeletingInfo?.record_id ? 'not-allowed' : ''
                                                }} 
                                                onClick={offering.record_id != currentDeletingInfo?.record_id ? () => handleDeleteProdct(offering.user_id, offering.record_id) : undefined} >
                                                  <i className="pull-right ml-1" title="Delete">
                                                    <FeatherIcon.Trash2 style={{width: "16px", height: "16px"}} className={`${currentDeletingInfo?.record_id != "" && offering.record_id == currentDeletingInfo?.record_id ? '': 'red'}`} />
                                                  </i>
                                                </span>
                                              }

                                              {offering?.user_id && offering.user_id != user?.id && (
                                              <i className="pull-right" title="Product added by admin">
                                                <FeatherIcon.Lock style={{width: "16px", height: "16px"}} className='img_trend' />
                                              </i>)}
                                            </td>
                                            
                                          </tr>
                                        ))}
                                      </tbody>
                                    </Table>
                                  </div>
                                </div>
                                {/* [END] => TARGET OFFERING TABLE */}


                                {/* [START] => TARGET OFFERING FORM */}
                                {showOfferingForm && (
                                  <div className="col-md-9 pl-0 mt-4 pr-0">
                                    <div
                                      className="border p-3"
                                      style={{ borderRight: "0px" }}
                                    >
                                      <h6 className="target_head">
                                        {selectedOffering?.record_id
                                          ? "Edit Product"
                                          : "Add New Product"}
                                      </h6>

                                      <Form.Group className="mb-3">
                                        {/* <Form.Label>Offering Name</Form.Label> */}
                                        <span
                                          className="lable_target mb-1"
                                          style={{
                                            left: "16px",
                                            zIndex: "9",
                                            fontSize: "12px",
                                            fontWeight: "400",
                                          }}
                                        >
                                          Product Name
                                        </span>
                                        <Form.Control
                                          type="text"
                                          name="name"
                                          className={`m-10 offering_form_input ${selectedOffering?.user_id && selectedOffering.user_id != user?.id ? 'disabled_admin_input' : ''}`}
                                          placeholder="Enter offering name"
                                          value={selectedOffering?.name || ""}
                                          onChange={(e) =>{
                                              setSelectedOffering((prev) => ({
                                                ...prev,
                                                name: e.target.value,
                                              }));
                                              // if (!/^[A-Za-z0-9]*$/.test(e.target.value.trim())) {
                                              //   setErrors((prev) => ({
                                              //     ...prev,
                                              //     [e.target.name]: "Only letters and numbers are allowed.",
                                              //   }));
                                              // } else {
                                                setErrors((prev) => ({
                                                  ...prev,
                                                  [e.target.name]: "",
                                                }));
                                              // }

                                            }
                                          }
                                          disabled={selectedOffering?.user_id && selectedOffering.user_id != user?.id}
                                        />
                                        {/* <Form.Control.Feedback type="invalid"> */}
                                          <span className="text-danger">
                                            {errors.name}
                                          </span>
                                        {/* </Form.Control.Feedback> */}
                                      </Form.Group>

                                      {/* <div className="offering_input_divider"></div> */}

                                      <Form.Group className="mb-3">
                                        <span
                                          className="lable_target mb-1"
                                          style={{
                                            left: "16px",
                                            zIndex: "9",
                                            fontSize: "12px",
                                            fontWeight: "400",
                                          }}
                                        >
                                          Product Description
                                        </span>
                                        <span
                                          // variant="outline-secondary"
                                          size="sm"
                                          className="generate_description_button"
                                          onClick={handleGenerateDescription}
                                          disabled={isGenerating}
                                        >
                                          {isGenerating
                                            ? "Generating..."
                                            : "Generate with AI"}
                                        </span>
                                        {/* </Form.Label> */}
                                        <Form.Control
                                          as="textarea"
                                          rows={3}
                                          className={`offering_form_input ${selectedOffering?.user_id && selectedOffering.user_id != user?.id ? 'disabled_admin_input' : ''}`}
                                          style={{
                                            marginTop: "10px",
                                          }}
                                          placeholder="Enter offering description"
                                          value={
                                            selectedOffering?.description || ""
                                          }
                                          onChange={(e) =>
                                            setSelectedOffering((prev) => ({
                                              ...prev,
                                              description: e.target.value,
                                            }))
                                          }
                                          disabled={selectedOffering?.user_id && selectedOffering.user_id != user?.id}
                                        />
                                        <Form.Control.Feedback type="invalid">
                                          {errors.description}
                                        </Form.Control.Feedback>
                                      </Form.Group>

                                      {/* <div className="offering_input_divider"></div> */}

                                      <Form.Group className="mb-3">
                                        <span
                                          className="lable_target mb-1"
                                          style={{
                                            left: "16px",
                                            zIndex: "9",
                                            fontSize: "12px",
                                            fontWeight: "400",
                                          }}
                                        >
                                          Contact Keywords (comma-separated)
                                        </span>
                                        <Form.Control
                                          type="text"
                                          style={{ marginTop: "0px" }}
                                          className={`offering_form_input ${selectedOffering?.user_id && selectedOffering.user_id != user?.id ? 'disabled_admin_input' : ''}`}
                                          placeholder="Add keywords"
                                          value={keywordInput}
                                          onChange={(e) => {
                                            const value = e.target.value;
                                            setKeywordInput(value);
                                          
                                            const keywordArray = value
                                              .split(",")
                                              .map((kw) => kw.trim())
                                              .filter((kw) => kw.length > 0);
                                          
                                            const invalidKeyword = keywordArray.find(
                                              (kw) => !/^[A-Za-z0-9 ]*$/.test(kw)
                                            );
                                          
                                            if (invalidKeyword) {
                                              setErrors((prev) => ({
                                                ...prev,
                                                contactKeywords: "Only letters and numbers are allowed in keywords.",
                                              }));
                                            } else {
                                              setErrors((prev) => ({
                                                ...prev,
                                                contactKeywords: "",
                                              }));
                                            }
                                          }}
                                          onBlur={() => {
                                            const newKeywords = keywordInput
                                              .split(",")
                                              .map((kw) => kw.trim())
                                              .filter((kw) => kw.length > 0);
                                          
                                            if (!isValidKeywordArray(newKeywords)) {
                                              setErrors((prev) => ({
                                                ...prev,
                                                contactKeywords: "Only letters and numbers are allowed in keywords.",
                                              }));
                                              return;
                                            }
                                          
                                            if (newKeywords.length) {
                                              setSelectedOffering((prev) => ({
                                                ...prev,
                                                contactKeywords: Array.from(
                                                  new Set([...(prev.contactKeywords || []), ...newKeywords])
                                                ),
                                              }));
                                              setKeywordInput("");
                                              setErrors((prev) => ({ ...prev, contactKeywords: "" }));
                                            }
                                          }}
                                          onKeyDown={(e) => {
                                            if (e.key === "Enter") {
                                              e.preventDefault();
                                              const newKeywords = keywordInput
                                                .split(",")
                                                .map((kw) => kw.trim())
                                                .filter((kw) => kw.length > 0);
                                          
                                              if (!isValidKeywordArray(newKeywords)) {
                                                setErrors((prev) => ({
                                                  ...prev,
                                                  contactKeywords: "Only letters and numbers are allowed in keywords.",
                                                }));
                                                return;
                                              }
                                          
                                              if (newKeywords.length) {
                                                setSelectedOffering((prev) => ({
                                                  ...prev,
                                                  contactKeywords: Array.from(
                                                    new Set([...(prev.contactKeywords || []), ...newKeywords])
                                                  ),
                                                }));
                                                setKeywordInput("");
                                                setErrors((prev) => ({ ...prev, contactKeywords: "" }));
                                              }
                                            }
                                          }}
                                          disabled={selectedOffering?.user_id && selectedOffering.user_id != user?.id}
                                        />
                                      </Form.Group>
                                      {errors?.contactKeywords && (
                                        <span className="text-danger">{errors.contactKeywords}</span>
                                      )}
                                      <div className="d-flex flex-wrap gap-2 mb-2">
                                        {selectedOffering?.contactKeywords &&
                                          selectedOffering?.contactKeywords?.map(
                                            (kw, idx) => (
                                              <span
                                                key={idx}
                                                className="badge bg-primary offering_contact_keywords"
                                              >
                                                {kw}
                                                {/* <button
                                                  type="button"
                                                  onClick={() => removeKeyword(idx)}
                                                  className="remove-keyword-btn"
                                                  aria-label={`Remove keyword ${kw}`}
                                                >
                                                  &times;
                                                </button> */}
                                              {(selectedOffering.user_id == user?.id) && (<i
                                                onClick={() => removeKeyword(idx)}
                                              >
                                                <FeatherIcon.Trash2
                                                      style={{
                                                        width: "16px",
                                                        height: "16px",
                                                        padding: "1px",
                                                        cursor: "pointer"
                                                      }}
                                                      className='img_trend ml-2'
                                                />
                                              </i>)}
                                              </span>
                                            )
                                          )}
                                      </div>

                                      {/* <div className="offering_input_divider"></div> */}

                                      <Form.Group className="mb-3">
                                        <span
                                          className="lable_target mb-1"
                                          style={{
                                            left: "16px",
                                            zIndex: "9",
                                            fontSize: "12px",
                                            fontWeight: "400",
                                          }}
                                        >
                                          Upload Files
                                        </span>
                                        <Form.Control
                                          type="file"
                                          className={`offering_form_input ${current_role_key === 'CLIENT_EMPLOYEE' && selectedOffering?.is_admin === 1 ? 'disabled_admin_input' : ''}`}
                                          multiple
                                          ref={fileInputRef}
                                          style={{
                                            marginTop: "0px",
                                          }}
                                          onChange={(e) =>
                                            handleFileUpload(e.target.files)
                                          }
                                          disabled={selectedOffering?.user_id && selectedOffering.user_id != user?.id}
                                        />
                                      </Form.Group>
                                      {selectedOffering?.documents?.length >
                                        0 && (
                                        <div className="mt-3 mb-3">
                                          <span className="lable_target mb-1">Uploaded Documents:</span>
                                          <div className="d-flex flex-wrap gap-2 mt-2">
                                            {selectedOffering.documents.map(
                                              (doc) => (
                                                <span
                                                  key={doc._id}
                                                  className="badge bg-secondary offering_document_view_download"
                                                  // title="Click to download"
                                                >
                                                  {doc.filename}
                                                  {user?.id === doc?.user_id && (<><i
                                                    onClick={() =>
                                                      downloadFile(
                                                        doc._id,
                                                        doc.filename
                                                      )
                                                    }
                                                    title="Click to download"
                                                  >
                                                    <FeatherIcon.Download
                                                      style={{
                                                        width: "16px",
                                                        height: "16px",
                                                        padding: "1px",
                                                        cursor: "pointer"
                                                      }}
                                                      className='img_trend ml-2'
                                                    />
                                                  </i>

                                                  <i
                                                    onClick={() =>
                                                      deleteFile(
                                                        doc._id,
                                                      )
                                                    }
                                                    title="Click to delete"
                                                  >
                                                    <FeatherIcon.Trash2
                                                      style={{
                                                        width: "16px",
                                                        height: "16px",
                                                        padding: "1px",
                                                        cursor: "pointer"
                                                      }} className='img_trend ml-2' />
                                                  </i></>)}
                                                </span>
                                              )
                                            )}
                                          </div>
                                        </div>
                                      )}

                                      {/* <div className="offering_input_divider"></div> */}
                                      {(<div style={{textAlign: "right"}}>

                                        {current_role_key != 'ANALYST' &&
                                        <Button
                                          variant="secondary"
                                          className="btn btn-secondary btn-sm mr-2"
                                          onClick={(e) => cancelAddingOfferings(e)}
                                        >
                                          Cancel
                                        </Button>
                                        }
                                        
                                        {current_role_key != 'ANALYST' && <Button
                                          variant="primary"
                                          className="personalisation_button"
                                          onClick={(e) => handleSaveOffering(e)}
                                        >
                                          Save
                                        </Button> }
                                      </div>)}
                                    </div>
                                  </div>
                                )}
                                {/* [END] => TARGET OFFERING FORM */}
                              
                                {/* Upload Offerings */}
                                {showOfferingUploadForm && 
                                  <div className="col-md-9 pl-0 mt-4 pr-0">
                                    <div
                                        className="border p-3"
                                        style={{ borderRight: "0px" }}
                                      >
                                        <h4 className="target_head">
                                          Upload Offerings
                                        </h4>

                                        <Form.Group className="mb-3">
                                          <div className="pl-3 ml-4 font14">
                                            <div className="mb-2">
                                              <label className="fw-bold">Step 1:</label> Download the 
                                                <a
                                                  href="../sample_files/client_product_list.csv"
                                                  download
                                                  className="ml-2 mt-2 text-primary"
                                                >
                                                  Sample file
                                                </a>.
                                            </div>
                                            <div className="mb-2">
                                              <label className="fw-bold">Step 2:</label> Update the file with your data.
                                            </div>
                                            <div className="mb-2">
                                              <label className="fw-bold">Step 3:</label> Upload the updated file here.
                                            </div>
                                          </div>
                                        </Form.Group>

                                        <Form.Group className="mb-3">
                                        {/* <Form.Label>Offering Name</Form.Label> */}
                                        <span
                                          className="lable_target mb-1"
                                          style={{
                                            left: "16px",
                                            zIndex: "9",
                                            fontSize: "12px",
                                            fontWeight: "400",
                                          }}
                                        >
                                          Upload Type:
                                        </span>
                                        <Form.Select aria-label="Default select example" 
                                        name="uploadType"
                                        className="form-control font14"
                                        onChange={handleUploadOfferingsFormChange}
                                        value={uploadOfferingsFormData.uploadType || ""}
                                        >
                                          <option>Select upload type</option>
                                          <option value="new_upload">New Upload</option>
                                          <option value="delete_and_upload">Delete and Upload</option>
                                          <option value="update_existing">Update Existing</option>
                                        </Form.Select>
                                          <span className="text-danger">
                                            {errors.uploadType}
                                          </span>
                                      </Form.Group>

                                        <Form.Group className="mb-3">
                                        <span
                                          className="lable_target mb-1"
                                          style={{
                                            left: "16px",
                                            zIndex: "9",
                                            fontSize: "12px",
                                            fontWeight: "400",
                                          }}
                                        >
                                          Upload Product List File:
                                        </span>
                                        <Form.Control
                                          type="file"
                                          accept=".csv"
                                          name="upload_product_file"
                                          placeholder="Upload Product File"
                                          onChange={ handleUploadOfferingsFormChange }
                                        />
                                          <span className="text-danger">
                                            {errors.upload_product_file}
                                          </span>
                                      </Form.Group>

                                      {(<div style={{textAlign: "right"}}>

                                        <Button
                                          variant="secondary"
                                          className="btn btn-secondary btn-sm mr-2"
                                          onClick={(e) => cancelAddingOfferings(e)}
                                        >
                                          Cancel
                                        </Button>

                                        <Button
                                          variant="primary"
                                          className="personalisation_button"
                                          onClick={(e) => handleUploadOfferings(e)}
                                        >
                                          Upload
                                        </Button>
                                      </div>)}
                                      
                                    </div>
                                </div>
                                }
                                {/* End: Upload Offerings */}
                                
                              </div>

                              
                              
                            </div>
                          )}
                          {/* [END] => TARGET OFFERING SECTION */}
                          {/* +++++++++++++++++++++++++++++++++++++++++++++ */}
                        </div>


                        {(activeTab === 'preferences') &&
                        <div className="col-md-12 pt-2">
                          <div className="prev_next_block float-end">
                            {/* <Button
                              type="button"
                              href="/dashboard"
                              className="previous_btn mr-2"
                            >
                              Cancel
                            </Button> */}
                            <Button
                              type="submit"
                              className="personalisation_button float-end"
                            >
                              Submit
                            </Button>
                          </div>
                        </div>}

                        {activeTab === "documents" && (
                          <div className="container-fluid">
                            <div className="user_profile_subblock">
                              {/* {apiError && (
                                <Alert type="danger" message={apiError} />
                              )}
                              {apiSuccess && (
                                <Alert type="success" message={apiSuccess} />
                              )} */}
                              <div className="offering_custom_card_block">
                                <div className="col-md-12 ">
                                  {/* {renderTable(
                                    "Template",
                                    templateFiles,
                                    "Template",
                                    setTemplateFiles
                                  )} */}
                                  {/* {renderTable("Pitch Documents", pitchFiles, "Pitch", setPitchFiles)} */}
                                  {/* +++++++++++++++++++++++++++++++++++++++++ */}
                                  <div className="mb-4">
                                    <div className="d-flex align-items-center justify-content-between pt-3 pb-3">
                                      <div className="d-inline-block">
                                        <h5 className="target_head mb-0">Document</h5>
                                      </div>
                                      <div className="d-inline-block float-end">
                                        <label
                                          className="personalisation_button btn btn-primary btn-sm"
                                          onClick={() => {
                                            setShowMemoryModal(true);
                                            // setSectionToUpload("Template");
                                            // setRefreshFn(() => () => fetchFiles("Template", setTemplateFiles));
                                          }}
                                        >
                                          Add Document
                                        </label>
                                      </div>
                                    </div>

                                    {/* ++++++++++++++++++++++++++++++ */}
                                    <div className="d-flex">
                                      {/* [START] => UPPER TABS */}
                                      <div className="navbar navbar-expand-lg container-fluid custom_subnavbar" style={{zIndex: "0"}}>
                                        <ul className="nav nav-tabs custom_nav_tab">
                                          <li className="nav-item">
                                            <a
                                              className={`nav-link ${
                                                activeDocTab === "products" ? "active" : ""
                                              }`}
                                              onClick={() => {
                                                handleDocTabChange("products");
                                                  // setSelectedOffering(offerings?.[0] || []);
                                                }
                                              }
                                            >
                                              Products
                                            </a>
                                          </li>
                                          <li className="nav-item">
                                            <a
                                              className={`nav-link ${
                                                activeDocTab === "use_case" ? "active" : ""
                                              }`}
                                              onClick={() => handleDocTabChange("use_case")}
                                            >
                                              Use Case
                                            </a>
                                          </li>
                                          <li className="nav-item">
                                            <a
                                              className={`nav-link ${
                                                activeDocTab === "vertical" ? "active" : ""
                                              }`}
                                              onClick={() => handleDocTabChange("vertical")}
                                            >
                                              Vertical
                                            </a>
                                          </li>
                                          <li className="nav-item">
                                            <a
                                              className={`nav-link ${
                                                activeDocTab === "global" ? "active" : ""
                                              }`}
                                              onClick={() => handleDocTabChange("global")}
                                            >
                                              Global
                                            </a>
                                          </li>
                                        </ul>
                                      </div>
                                      {/* [END] => UPPER TABS */}
                                    </div>
                                    {/* ++++++++++++++++++++++++++++++ */}
                                    {activeDocTab === 'products' && renderTable(productDocs) }
                                    {activeDocTab === 'use_case' && renderTable(useCaseTypeDocs) }
                                    {activeDocTab === 'vertical' && renderTable(verticalDocs) }
                                    {activeDocTab === 'global' && renderTable(globalDocs) }
                                  </div>
                                  {/* +++++++++++++++++++++++++++++++++++++++++ */}
                                  <MemoryModal />
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                      </Form>

                      {(activeTab === 'accounts') &&
                        <div className="row mx-1" >
                            <AccountList />
                        </div>
                        }

                        {(activeTab === 'users') &&
                        <div className="row mx-1">
                          <UserList />
                        </div>
                        }

                        {(activeTab === 'contact_settings') &&
                        <div className="row mx-1">
                          <ContactSettings />
                        </div>
                        }

                        {(activeTab === 'signals') &&
                        <div className="row mx-1">
                          <Signals />
                        </div>
                        }

                        {
                          activeTab === "auto_nurture" && (
                            <AutoNurtureMemory/>
                          )
                        }

                        
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <ConfirmDialog
          show={currentDeletingInfo?.record_id ? true : false}
          handleClose={hideDeleteConfirm}
          handleConfirm={confirmDelete}
          title="Delete Product"
          message="Are you sure you want to delete this product ?" />
          
      </div>
    </>
  );
}